<template>
  <div class="auth-wrapper auth-v1">
    <div class="auth-inner">
      <v-card class="auth-card">
        <!-- logo -->
        <v-card-title class="d-flex align-center justify-center py-7">
          <h2 class="text-center">InLab</h2>
        </v-card-title>

        <!-- login form -->
        <v-card-text>
          <v-form 
            v-model="formValid" 
            :disabled="processing" 
            @submit.prevent="formValid && submitLogin()"
          >
            <v-text-field
              v-model="username"
              class="mb-2"
              outlined
              label="Username"
              :rules="[v => !!v || 'Please fill in username']"
            ></v-text-field>

            <v-text-field
              v-model="password"
              outlined
              :type="isPasswordVisible ? 'text' : 'password'"
              label="Password"
              :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
              :rules="[v => !!v || 'Please fill in password']"
              @click:append="isPasswordVisible = !isPasswordVisible"
            ></v-text-field>

            <v-btn
              depressed
              :loading="processing"
              :disabled="!formValid"
              block
              elevation="0"
              color="primary"
              class="mt-6"
              type="submit"
              @click="formValid && submitLogin()"
            >
              Login
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </div>

    <v-snackbar v-model="loginError" timeout="4000" color="error" top>
      <div class="d-flex align-center">
        <v-icon class="mr-2" color="white">
          {{ icons.mdiAlertOctagon }}
        </v-icon>
        {{ errorMsg }}
      </div>
      <template #action="{ attrs }">
        <v-btn depressed color="white" icon v-bind="attrs" @click="loginError = false">
          <v-icon>{{ icons.mdiClose }}</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mdiEyeOutline, mdiEyeOffOutline, mdiClose, mdiAlertOctagon } from '@mdi/js'
import { defaultPage } from '@/assets/cannotAccessList'

export default {
  name: 'Login',
  computed: {
    processing() {
      return this.$store.getters.isLoading
    }
  },
  data: () => ({
    formValid: false,
    loginError: false,
    isPasswordVisible: false,
    errorMsg: '',

    username: '',
    password: '',

    icons: {
      mdiEyeOutline,
      mdiEyeOffOutline,
      mdiClose,
      mdiAlertOctagon,
    },
  }),

  methods: {
    async submitLogin() {
      if (this.processing) {
        return;
      }

      if (!this.$validate.DataValid(this.username) || !this.$validate.DataValid(this.password)) {
        this.errorMsg = 'Please fill in all required fields';
        this.loginError = true;
        return;
      }

      this.loginError = false;
      this.$store.dispatch('setLoading', true);

      try {
        const data = await this.$Fetcher.Login(this.username, this.password);
        await this.setUserData({
          id: data.id,
          user_type: data.user_type,
          last_login: data.last_login,
          username: data.username,
        })
       
        if (this.$validate.DataValid(defaultPage[data.user_type])) {
          this.$router.replace(defaultPage[data.user_type]);
        }
      } catch(err) {
        this.$common.error(err);
        this.errorMsg = err;
        this.loginError = true;
        this.$store.dispatch('setLoading', false);
      }
    },
  },
}
</script>

<style lang="scss">
@import '~@/plugins/vuetify/default-preset/preset/pages/auth.scss';
</style>
